@import '../../../../design-tokens/dist/private/colors';

:host {
	display: block;
	margin: var(--zds-space-2) 0;
}

:host([light]) {
	--zds-divider-color: var(--zds-divider-color-light);
}

.zds-divider {
	background-color: var(--zds-divider-color);
	border-width: 0;
	height: 1px;
	margin: 0;
	opacity: var(--zds-divider-opacity);
	width: 100%;
}

:host([vertical]) {
	height: 100%;
	margin: 0 var(--zds-space-2);
	width: 1px;

	.zds-divider {
		height: 100%;
		width: 1px;
	}
}
